import { render } from "./SafaName.vue?vue&type=template&id=268b1d7a&ts=true"
import script from "./SafaName.vue?vue&type=script&lang=ts"
export * from "./SafaName.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__